module.exports = __webpack_public_path__ + "121708398e3ee97fba5bf0eacee69e53.svg";


//////////////////
// WEBPACK FOOTER
// ./~/onsenui/css-components-src/src/img/ios-search-input-icon.svg
// module id = 335
// module chunks = 1